import _ from 'underscore';
import queryString from 'query-string';
import { Environment, getEnvironment } from './get-environment';

const SMART_PAGE_ENV_MAPPING = {
  '.biz.site': Environment.PROD,
  '.beta.smartpage.microsoft.com': Environment.BETAPROD,
  '.si.smartpage.microsoft.com': Environment.SI,
  '.ci.smartpage.microsoft.com': Environment.CI,
  '.betasi.smartpage.microsoft.com': Environment.BETASI,
};

const ENV_LANDING_PAGE_DOMAIN_MAPPING = {
  [Environment.PROD]: 'ui.ads.microsoft.com',
  [Environment.BETAPROD]: 'ui.beta.ads.microsoft.com',
  [Environment.SI]: 'ui.ads-int.microsoft.com',
  [Environment.BETASI]: 'ui.beta.ads-int.microsoft.com',
  [Environment.CI]: 'ccui.devdev.bingads.microsoft.com',
  [Environment.TIP]: 'ui.tip.ads.microsoft.com',
};

export const getSmartPageEnviroment = (domain) => {
  let enviroment = null;
  const keys = _.keys(SMART_PAGE_ENV_MAPPING);

  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];

    if (domain.indexOf(key) >= 0) {
      enviroment = SMART_PAGE_ENV_MAPPING[key];
      break;
    }
  }

  return enviroment;
};

export const getLandingPageUrl = (domain, queries = {}) => {
  const env = getSmartPageEnviroment(domain) || getEnvironment(domain);
  const landingPageDomain = ENV_LANDING_PAGE_DOMAIN_MAPPING[env];
  const landingPagePath = '/campaign/smartpage';

  const appendedQueries = queryString.stringify(queries, {
    skipNull: true,
    skipEmptyString: true,
  });
  const formattedQueries = appendedQueries ? `?${appendedQueries}` : '';

  return `//${landingPageDomain}${landingPagePath}${formattedQueries}`;
};
